














































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import router from '@/router';
import { getModule } from 'vuex-module-decorators';
import BasicInputForm from '@/components/forms/BasicInputForm.vue';
import ListInput from '@/components/forms/ListInput.vue';
import SupportWindow from '@/components/common/SupportWindow.vue';
//@ts-ignore
import { NotificationEventBus } from '@/EventBus';
import Sticky from 'vue-sticky-directive';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ScoringKeyEditor from '@/components/scoring-key/ScoringKeyEditor.vue';
import Users from '@/store/modules/Users';
import Modelling from '@/store/modules/Modelling';
import Viewpoints from '@/store/modules/Viewpoints';
import Decisions from '@/store/modules/Decisions';
import Choices from '@/store/modules/Choices';
import ScoringKeyEditorDialog from '@/components/scoring-key/ScoringKeyEditorDialog.vue';
import { Urls } from '@/Urls';
import ViewpointNavigation from '@/components/navigation/ViewpointNavigation.vue';
import FactorNavigationWorkingModel from '@/components/navigation/FactorNavigationWorkingModel.vue';
import FactorNavigationPublishedModel from '@/components/navigation/FactorNavigationPublishedModel.vue';
import ChoiceNavigation from '@/components/navigation/ChoiceNavigation.vue';
import ScoringKeys, { ScoringKeyDefinition } from '@/store/modules/ScoringKeys';
import ChoiceVisibilitySelectorMenu from '@/components/workspace-options/ChoicesVisibilitySelectorMenu.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import DecisionShareDialog from '@/components/decisions/DecisionManageUsersDialog.vue';
import CommentThreadDisplay from '@/components/comments/CommentThreadDisplay.vue';
import CommentThreadPanel from '@/components/comments/CommentThreadPanel.vue';
import ResourceEditingPanel from '@/components/panel/ResourceEditingPanel.vue';
import FactorScoringDefinitionCreatorVuexDialog from '@/components/scoring-definition/FactorScoringDefinitionCreatorVuexDialog.vue';
import VuexDialogScoringKeyEditor from '@/components/scoring-key/ScoringKeyEditorVuexDialog.vue';
import FactorContributionVisibilitySwitch from '@/components/workspace-options/FactorContributionVisibilitySwitch.vue';
import ChoiceInputShareDialog from '@/components/share/ChoiceInputShareDialog.vue';
import ChoiceScoreInputShareDialog from '@/components/share/ChoiceScoreInputShareDialog.vue';
import { Decision } from '@/api/model/Decision';
import { Viewpoint } from '@/api/model/Viewpoint';
import _ from 'lodash';
import ViewpointFactorVisibilityEditorVuexDialog from '@/components/viewpoint-factor-visibility/ViewpointFactorVisibilityEditorVuexDialog.vue';
import ListManager from '@/components/Lists/ListManager.vue';
import ChoiceListSelection from '@/components/Lists/ChoiceListSelection.vue';
import ViewpointListSelection from '@/components/Lists/ViewpointListSelection.vue';
import FactorListSelection from '@/components/Lists/FactorListSelection.vue';
import ChoiceListInputDialog from '@/components/Lists/ChoiceListInputDialog.vue';
import FactorListInputDialog from '@/components/Lists/FactorListInputDialog.vue';
import ViewpointListInputDialog from '@/components/Lists/ViewpointListInputDialog.vue';
import Apps from '@/store/modules/Apps';
import DecisionSelector from '@/components/common/DecisionSelector.vue';
import ChartDialog from '@/components/chart/ChartDialog.vue';
import UiSettingMenu from '@/views/UiSettings/UiSettingMenu.vue';
import HotSpotHelp from '@/components/common/HotSpotHelp.vue';
import Scoring from '@/store/modules/Scoring';
import AddToApps from '@/components/apps/AddToApps.vue';
import MainCommentPanel from '@/components/common/MainCommentPanel.vue';
import LeftNavDragBar from '@/components/common/LeftNavDragBar.vue';
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import { AppModel } from '@/api/model/AppModel';
import { BILLINGS as billingsDao } from "@/api/BillingsDao";
import vuetify from '@/plugins/vuetify';

const usersModule = getModule(Users);
const modellingModule = getModule(Modelling);
const viewpointsModule = getModule(Viewpoints);
const decisionsModule = getModule(Decisions);
const choicesModule = getModule(Choices);
const scoringKeysModule = getModule(ScoringKeys);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const appsModule = getModule(Apps);
const scoringModule = getModule(Scoring);

@Component({
    components: {
        ViewpointFactorVisibilityEditorVuexDialog,
        ChoiceScoreInputShareDialog,
        ChoiceInputShareDialog,
        FactorContributionVisibilitySwitch,
        VuexDialogScoringKeyEditor,
        FactorScoringDefinitionCreatorVuexDialog,
        ResourceEditingPanel,
        CommentThreadPanel,
        CommentThreadDisplay,
        ScoringKeyEditorDialog,
        ScoringKeyEditor,
        BasicForm: BasicInputForm,
        ListInput,
        SupportWindow,
        ConfirmationDialog,
        ViewpointNavigation,
        FactorNavigationWorkingModel,
        FactorNavigationPublishedModel,
        ChoiceNavigation,
        ChoiceVisibilitySelectorMenu,
        DecisionShareDialog,
        ListManager,
        ChoiceListSelection,
        ViewpointListSelection,
        FactorListSelection,
        ChoiceListInputDialog,
        FactorListInputDialog,
        ViewpointListInputDialog,
        DecisionSelector,
        ChartDialog,
        UiSettingMenu,
        HotSpotHelp,
        AddToApps,
        MainCommentPanel,
        LeftNavDragBar
    },
    directives: {
        Sticky,
    },
})
export default class ViewpointApp extends Vue {
    @Prop()
    queryActiveViewpointId!: string;

    @Prop()
    queryViewpointIds!: string[] | string;

    @Prop()
    queryDecisionId!: string;

    @Prop()
    queryChoiceListIds!: string[];

    @Prop()
    queryActiveFactorId!: string;

    @Prop()
    queryFactorListIds!: string[];

    @Prop()
    queryViewpointListIds!: string[];

    @Prop()
    queryShowDesc!: string;

    @Prop()
    queryShowIconScoring!: string;

    @Prop()
    querySkipGroups!: string;

    @Prop()
    queryShowNonListFactors!: string;

    @Prop()
    queryShowBars!: string;

    @Prop()
    queryChoiceId!: string;

    @Prop()
    queryShowNonContributing!: string;

    @Prop()
    queryVisibleChoices!: string[];

    @Prop()
    navDrawerProp!: boolean;

    @Prop()
    queryChoiceSort!: string;

    @Prop()
    queryViewpointSort!: string;

    @Prop()
    queryOpenLeft!: string;

    @Prop()
    queryOpenRight!: string;

    @Prop()
    queryViewpointColumnWidth!: string;

    @Prop()
    queryChoiceColumnWidth!: string;

    @Prop()
    queryChoiceNumOfCols!: string;

    @Prop()
    queryTrimTopGroups!: string;

    @Prop()
    queryShowScores!: string;

    @Prop()
    queryShowKeys!: string;

    @Prop()
    queryShowComments!: string;

    @Prop()
    queryChoiceFirstCol!: string;

    @Prop()
    queryShowCustomRange!: string;

    @Prop()
    queryViewpointFirstCol!: string;

    @Prop()
    queryRankChoiceCol!: string;

    @Prop()
    queryPinnedRight!: string;

    @Prop()
    queryPinnedLeft!: string;

    @Prop()
    queryCommentVertical!: string;

    @Prop()
    queryAllowGenerateViewpoints!: string;

    @Prop()
    querySelectionMenu!: string;

    @Prop()
    queryViewpointSelectionMenu!: string;
    
    @Prop()
    queryChoiceSelectionMenu!: string;
    
    @Prop()
    queryFactorSelectionMenu!: string;

    @Prop()
    queryMbDraggable!: string;

    @Prop()
    queryDenomScoring!: string;

    @Prop()
    queryStandardize!: string;

    @Prop()
    queryShowFactorData!: string;

    private readonly URLS = Urls;
    private initialLoad = true;
    private increment: number = 1;

    navDrawer: boolean = this.navDrawerProp;
    showHelp: boolean = false;

    private loadingResources = false;
    private processing = false;

    private createDecisionDialog = false;
    private editDecisionDialog = false;
    private createViewpointDialog = false;

    private section: string = this.URLS.TEMPLATE_BUILDER;
    private fullPath: string = '';

    private sliderPageWidth: any[] = [-50, 50];
    private sliderLeft: number = -50;
    private sliderRight: number = 50;

    private navTabs: number = 0;
    private scoreTabs: string = '';

    private searchFactors: string | null = null;
    private decisionSelectorMenuShow: boolean = false;


    get commentRightWidth() {
        return workspaceOptionsModule.commentRightWidth;
    }

    get commentBottomHeight() {
        return workspaceOptionsModule.commentBottomHeight;
    }

    get openLeft(){
        // this.generateUrl();
        return workspaceOptionsModule.openLeft;
    }

    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get openRight(){
        // this.generateUrl();
        return workspaceOptionsModule.openRight;
    }
    
    get standardizeDenominator() {
        return workspaceOptionsModule.standardizeDenominator

    }

    get denominatorScoring() {
        return workspaceOptionsModule.denominatorScoring

    }

    get isOwner(): boolean {
        return this.userId != null && this.userId === this.decisionOwnerUserId;
    }

    get isAdmin() {
        if(decisionsModule 
            && decisionsModule.selectedDecisionUsers 
            && this.currentUserProfile
            && decisionsModule.selectedDecisionUsers[this.currentUserProfile.userId]
        ){
            return decisionsModule.selectedDecisionUsers[this.currentUserProfile.userId].permissionAccess === 'ADMIN';
        }else{
            return false;
        }
        
    }
    get mainPageStyle(){
        if (this.commentVertical && this.pinnedRight){
            return `max-height:calc(100vh - ${110 + this.commentBottomHeight}px)`
        }else{
            return `max-height:calc(100vh - 110px)`
        }
       
    }
    

    get userId(): string | undefined {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
        return undefined;
    }

    get decisionOwnerUserId(): string | undefined {
        if (decisionsModule.selectedDecision) {
            return decisionsModule.selectedDecision.ownerUserId;
        }
    }

    get sectionName() {
        for(let item of this.scoreItems){
            if(item.url === this.scoreTabs){
                return item.text;
            }
        }
        return '';   
    }

    get scoreItems() {
        let items = [
            {text: `${this.singularChoiceLabel} Manager`, tooltip: '', url: this.URLS.CHOICE_MANAGER, section: this.URLS.CHOICE_MANAGER},
            {text: `${this.singularChoiceLabel} Editor`, tooltip: '', url: this.URLS.CHOICE_SUBMITTER, section: this.URLS.CHOICE_MANAGER},
            {text: `${this.singularChoiceLabel} Cards`, tooltip: '', url: this.URLS.CHOICE_CARDS, section: this.URLS.CHOICE_MANAGER},
            {text: `${this.singularViewpointLabel} Manager`, url: this.URLS.VIEWPOINT_MANAGER, section: this.URLS.VIEWPOINT_MANAGER },
            {text: 'Weights & Rules', tooltip: '', url: this.URLS.WEIGHTING, section: this.URLS.VIEWPOINT_MANAGER},
            {text: `Compare ${this.pluralChoiceLabel}`, tooltip: '', url: this.URLS.CHOICE_SCORER_COMPARE, section: this.URLS.VIEWPOINT_MANAGER},
            {text: `Compare ${this.pluralViewpointLabel}`, tooltip: '', url: this.URLS.CHOICE_SCORER, section: this.URLS.VIEWPOINT_MANAGER},
            {text: `Rank ${this.pluralChoiceLabel}`, tooltip: '', url: this.URLS.CHOICE_SCORER_BINS, section: this.URLS.VIEWPOINT_MANAGER},
            {text: `Insights`, tooltip: '', url: this.URLS.INSIGHTS, section: this.URLS.VIEWPOINT_MANAGER},
            {text: 'List Manager', tooltip: '', url: this.URLS.LIST_MANAGER, section: this.URLS.LIST_MANAGER},
        ];

        let decisionUsers = decisionsModule.selectedDecisionUsers;
        if (
            this.currentUserProfile &&
            decisionUsers[this.currentUserProfile.userId] &&
            ['OWNER', 'ADMIN'].includes(
                decisionUsers[this.currentUserProfile.userId].permissionAccess
            )
        ) {
            items.splice(0, 0, {
                text: `${this.singularFactorLabel} Editor`,
                tooltip: '',
                url: this.URLS.TEMPLATE_BUILDER,
                section: this.URLS.TEMPLATE_BUILDER,
            });
            if (this.$route.path === this.URLS.TEMPLATE_BUILDER) {
                this.scoreTabs = this.URLS.TEMPLATE_BUILDER;
            }
        }
        return items;
    }

    get leftPanelWidth() {
        return workspaceOptionsModule.leftPanelWidth;
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get selectedFactorResourceItemId() {
        return workspaceOptionsModule.selectedPathItemId;
    }

    get draftFactorResources() {
        return modellingModule.workingModelFactorResources;
    }

    get selectedDraftFactorResourceItemId() {
        return workspaceOptionsModule.draftSelectedPathItemId;
    }

    get selectedChoiceName() {
        return this.selectedChoice
            ? this.selectedChoice.name
            : '- select one -';
    }

    get selectedViewpointName() {
        if (this.viewpoints.hasOwnProperty(this.activeViewpointId)) {
            return this.viewpoints[this.activeViewpointId].name;
        }
        return '- select one -';
    }

    get selectedFactorName() {
        if (this.selectedFactorResourceItemId && this.factorResources.hasOwnProperty(this.selectedFactorResourceItemId)) {
            return this.factorResources[this.selectedFactorResourceItemId].name;
        }
        return '- select one -';
    }

    get viewpoints() {
        return viewpointsModule.decisionViewpointsMap || {};
    }

    get activeViewpointId() {
        return viewpointsModule.activeViewpointId || '';
    }

    set activeViewpointId(viewpointId: string) {
        if (viewpointId) {
            viewpointsModule.selectActiveViewpoint(viewpointId);
        }
    }

    get descriptionVisibility() {
        return workspaceOptionsModule.descriptionVisibility;
    }

    get scoresVisibility() {
        return workspaceOptionsModule.scoresVisibility;
    }

    get keysVisibility() {
        return workspaceOptionsModule.keysVisibility;
    }

    get commentsVisibility() {
        return workspaceOptionsModule.commentsVisibility;
    }

    get scoreBarVisibility() {
        return workspaceOptionsModule.scoreBarVisibility;
    }

    get trimTopGroups() {
        return workspaceOptionsModule.trimTopGroups;
    }

    get currentUserProfile() {
        return usersModule.currentUserProfile;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    }
    
    get selectedViewpointIds() {
        return viewpointsModule.selectedViewpointIds;
    }

    get activeFactorLists() {
        return workspaceOptionsModule.activeFactorLists || []
    }

    get autoCalc() {
        return workspaceOptionsModule.autoCalc;
    }

    set selectedViewpoints(selectedViewpoints: Viewpoint[] | undefined) {
        if (!selectedViewpoints) return;
        let chosenViewpointIds = selectedViewpoints.map((v) => v.viewpointId);
        let viewpointsToAdd = _.pullAll(
            chosenViewpointIds,
            viewpointsModule.selectedViewpointIds
        );
        let viewpointsToRemove = _.pullAll(
            viewpointsModule.selectedViewpointIds,
            chosenViewpointIds
        );
        viewpointsToRemove.forEach(viewpointsModule.deselectViewpoint);
        viewpointsToAdd.forEach(viewpointsModule.selectViewpoint);
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    set openLeft(open: boolean) {
        workspaceOptionsModule.setOpenLeft(open);
    }

    set openRight(open: boolean) {
        workspaceOptionsModule.setOpenRight(open);
    }

    set commentVertical(vertical: boolean) {
        workspaceOptionsModule.setCommentVertical(vertical);
    }

    // Help & Support - START
    get showHelpHotSpots() {
        return workspaceOptionsModule.showHelpHotSpots;
    }
    // Help & Support - END

    setSelectedDecision(){
        if (
            this.decisionViewpointsList &&
            this.decisionViewpointsList.length > 0
        ) {
            viewpointsModule.selectViewpoint(
                this.decisionViewpointsList[0].viewpointId
            );
            viewpointsModule.setActiveViewpointId(this.decisionViewpointsList[0].viewpointId);
            workspaceOptionsModule.resetViewpointColumnsWidth();
        }

        if (this.choicesList && this.choicesList.length) {
            choicesModule.selectChoice(this.choicesList[0].id);
            workspaceOptionsModule.resetChoiceColumnsWidth();
        }
        
        if (
            this.currentUserProfile &&
            this.selectedDecision &&
            this.currentUserProfile.userId !==
                this.selectedDecision.ownerUserId
        ) {
            if (this.$route.name !== 'ChoiceSubmitter') {
                this.$router.push({ name: 'ChoiceSubmitter' });
            }
            this.section = this.URLS.CHOICE_SUBMITTER;
        } else {
            if (this.$route.name !== 'DecisionBuilder') {
                this.$router.push({ name: 'DecisionBuilder' });
            }
            this.section = this.URLS.TEMPLATE_BUILDER;
        }
    }

    get selectedChoice() {
        return choicesModule.selectedChoice;
    }

    set selectedChoice(selectedChoice: any) {
        if (selectedChoice) {
            choicesModule.setSelectedChoiceId(selectedChoice.id);
        } else {
            choicesModule.setSelectedChoiceId(null);
        }
    }

    get decisionViewpointsList() {
        if (this.selectedDecision) {
            return decisionsModule.decisionViewpoints[
                this.selectedDecision.decisionId
            ];
        }
        return [];
    }

    get decisions() {
        return Object.values(decisionsModule.decisions).sort(
            (a: any, b: any) => {
                if (a.name === null || a.name === undefined) a.name = '';
                if (b.name === null || b.name === undefined) b.name = '';
                return a.name.localeCompare(b.name);
            }
        );
    }

    get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

    get singularFactorLabel() {
        return decisionsModule.singularFactorLabel;
    }

    get pluralFactorLabel() {
        return decisionsModule.pluralFactorLabel;
    }

    get choices() {
        return choicesModule.choices;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get loading() {
        return this.loadingResources || this.processing;
    }

    get pageWidth(): number {
        return this.sliderPageWidth[1] - this.sliderPageWidth[0];
    }

    get url() {
        return this.generateUrl();
    }

    get skipGroups() {
        return workspaceOptionsModule.skipGroups;
    }

    get showNonListFactors() {
        return workspaceOptionsModule.showNonListFactors;
    }

    get showIconScoring() {
        return workspaceOptionsModule.showIconScoring
    }

    get pinnedRight() {
        if (this.selectedDecision) {
            return workspaceOptionsModule.pinnedRight
        }
        return false;
    }

    set pinnedRight(val: boolean) {
        workspaceOptionsModule.changePinnedRight(val)
    }

    mounted() {
        console.log('mounted')
        if (this.$route.path === '/') {
            this.section = this.URLS.TEMPLATE_BUILDER;
            this.navTabs = 0;
        } else if (this.$route.path === this.URLS.TEMPLATE_BUILDER) {
            this.navTabs = 0;
            this.section = this.URLS.TEMPLATE_BUILDER;
        } else if (this.$route.path === this.URLS.CHOICE_SUBMITTER) {
            this.section = this.URLS.CHOICE_MANAGER;
            this.navTabs = 1;
        } else if (this.$route.path === this.URLS.CHOICE_CARDS) {
            this.section = this.URLS.CHOICE_MANAGER;
            this.navTabs = 1;
        } 
         else {
            this.section = this.URLS.VIEWPOINT_MANAGER;
            this.navTabs = 2;
        }

        if (this.$cookies.isKey('vp-form-width')) {
            //Set the page width if there is a cookie here
            // this.sliderRight = this.$cookies.get('vp-form-width');
            this.sliderRight = 50;
            this.sliderLeft = -1 * this.sliderRight;
        }

        // if (Vue.$cookies.isKey("vp__skip__groups")) {
        //     workspaceOptionsModule.setSkipGroups(Vue.$cookies.get("vp__skip__groups"));
        // }
        
        /* All Set to true for main tool in case user goes from 
            Applet Embed to the home screen */
        workspaceOptionsModule.setEditComments( true );
        workspaceOptionsModule.setEditModel( true );
        workspaceOptionsModule.setEditContent( true );
        workspaceOptionsModule.setEditWeights( true );
        workspaceOptionsModule.setEditSumRule( true );
        workspaceOptionsModule.setEditScoringRule( true );
        workspaceOptionsModule.setEditScores( true );

        this.initialize();
        // setTimeout(() => this.increment++, 10000);
        // setTimeout(() => this.increment++, 20000);

        this.sliderPageWidth = [this.sliderLeft, this.sliderRight];

        NotificationEventBus.getEventBus().$on(
            'choice-updated',
            (choice: any) => {
                choicesModule.setChoice(choice);
            }
        );
    }

    async initialize() {
        await decisionsModule.fetchDecisions();
        if (this.queryDecisionId) {
            await decisionsModule.selectDecision(this.queryDecisionId);
           await appsModule.fetchAppsByDecision(this.queryDecisionId);
           // await appsModule.fetchMarketplaceItems();
            if (
                this.queryViewpointIds &&
                Array.isArray(this.queryViewpointIds) &&
                this.queryViewpointIds.length
            ) {
                this.queryViewpointIds.forEach(
                    viewpointsModule.selectViewpoint
                );
            } else if (!Array.isArray(this.queryViewpointIds)) {
                viewpointsModule.selectViewpoint(this.queryViewpointIds);
            } else if (this.decisionViewpointsList.length > 0) {
                viewpointsModule.selectViewpoint(
                    this.decisionViewpointsList[0].viewpointId
                );
            }

            if (this.queryActiveViewpointId) {
                viewpointsModule.selectActiveViewpoint(
                    this.queryActiveViewpointId
                );
            }

            if (this.queryChoiceId) {
                choicesModule.selectChoice(this.queryChoiceId);
            } else if (choicesModule.choiceIds.length) {
                choicesModule.selectChoice(choicesModule.choiceIds[0]);
            }

        }
        else {
            this.$router.push({ name: 'DecisionManager' });
        }
        
        // if (this.queryVisibleChoices) {
        //     workspaceOptionsModule.showSetChoicesOnly(this.queryVisibleChoices);
        // }
        if (this.queryChoiceListIds != null) {
            workspaceOptionsModule.updateSavedChoiceLists((typeof this.queryChoiceListIds === 'string')? [this.queryChoiceListIds]: this.queryChoiceListIds);
        }

        if (this.queryFactorListIds != null) {
            // console.log(typeof this.queryFactorListIds)
            workspaceOptionsModule.updateSavedFactorLists((typeof this.queryFactorListIds === 'string')? [this.queryFactorListIds]: this.queryFactorListIds);
        }

        if (this.queryViewpointListIds != null) {
            workspaceOptionsModule.updateSavedViewpointLists((typeof this.queryViewpointListIds === 'string')? [this.queryViewpointListIds]: this.queryViewpointListIds);
        }

        // if (this.queryShowNonContributing != null) {
        //     workspaceOptionsModule.changeContributingFactorVisibility(
        //         this.queryShowNonContributing == 'true'
        //     );
        // }

        if (this.queryActiveFactorId != null) {
            workspaceOptionsModule.selectBreadcrumbItem(this.queryActiveFactorId);
        }

        if (this.queryShowBars != null) {
            workspaceOptionsModule.setScoreBarVisibility(this.queryShowBars === 'true');
        } 

        if (this.queryShowScores != null) {
            workspaceOptionsModule.setScoresVisibility(this.queryShowScores === 'true');
        }

        if (this.queryShowKeys != null) {
            workspaceOptionsModule.setKeysVisibility(this.queryShowKeys === 'true');
        }

        if (this.queryShowComments != null) {
            workspaceOptionsModule.setKeysVisibility(this.queryShowComments === 'true');
        }
        
        if (this.queryShowDesc != null) {
            workspaceOptionsModule.setDescriptionVisibility(this.queryShowDesc === 'true');
        }

        // console.log(this.queryShowIconScoring)
        if (this.queryShowIconScoring != null) {
            workspaceOptionsModule.changeIconScoring(this.queryShowIconScoring === 'true');
        }

        if (this.querySkipGroups != null) {
            workspaceOptionsModule.changeSkipGroups(this.querySkipGroups == 'true');
        }

        if (this.queryShowNonListFactors != null) {
            workspaceOptionsModule.setShowNonListFactors(this.queryShowNonListFactors == 'true');
        }

        if (this.queryChoiceSort != null) {
            workspaceOptionsModule.changeChoiceSort(parseInt(this.queryChoiceSort));
        }

        if (this.queryViewpointSort != null) {
            workspaceOptionsModule.changeViewpointSort(parseInt(this.queryViewpointSort))
        }

        if (this.queryOpenLeft != null) {
            workspaceOptionsModule.setOpenLeft(this.queryOpenLeft === 'true');
        }

        if (this.queryOpenRight != null) {
            workspaceOptionsModule.setOpenRight(this.queryOpenRight === 'true');
        }

        if (this.queryChoiceColumnWidth != null) {
            workspaceOptionsModule.changeChoiceColumnWidth(Number(this.queryChoiceColumnWidth));
        } else {
            workspaceOptionsModule.changeChoiceColumnWidth(200);
        }

        if (this.queryChoiceFirstCol != null) {
            workspaceOptionsModule.setChoiceFirstCol(Number(this.queryChoiceFirstCol));
        } else {
            workspaceOptionsModule.setChoiceFirstCol(600);
        }

        if (this.queryViewpointFirstCol != null) {
            workspaceOptionsModule.setViewpointFirstCol(Number(this.queryViewpointFirstCol));
        } else {
            workspaceOptionsModule.setViewpointFirstCol(600);
        }

        if (this.queryViewpointColumnWidth != null) {
            workspaceOptionsModule.changeViewpointColumnWidth(Number(this.queryViewpointColumnWidth));
        } else {
            workspaceOptionsModule.changeViewpointColumnWidth(200);
        }

        if (this.queryRankChoiceCol != null) {
            workspaceOptionsModule.setRankChoiceCol(Number(this.queryRankChoiceCol));
        } else {
            workspaceOptionsModule.setRankChoiceCol(150);
        }

        if (this.queryChoiceNumOfCols != null) {
            workspaceOptionsModule.setNumOfCols(Number(this.queryChoiceNumOfCols));
        } else {
            workspaceOptionsModule.setNumOfCols(3);
        }
        
        if (this.queryTrimTopGroups != null) {
            workspaceOptionsModule.changeTrimTopGroups(this.queryTrimTopGroups === 'true');
        }

        if (this.queryShowCustomRange != null) {
            workspaceOptionsModule.changeCustomRangeActive(this.queryShowCustomRange === 'true');
        }

        if (this.queryPinnedRight != null) {
            workspaceOptionsModule.setPinnedRight(this.queryPinnedRight === 'true');
        }

        if (this.queryPinnedLeft != null) {
            workspaceOptionsModule.setPinnedLeft(this.queryPinnedLeft === 'true');
        }

        if (this.queryCommentVertical != null) {
            workspaceOptionsModule.setCommentVertical(this.queryCommentVertical === 'true');
        }

        if (this.queryAllowGenerateViewpoints != null) {
            workspaceOptionsModule.setAllowGenerateViewpoints(this.queryAllowGenerateViewpoints === 'true');
        }

        if (this.querySelectionMenu != null) {
            appsModule.setSelectionMenu(this.querySelectionMenu === 'true');
        }

        if (this.queryViewpointSelectionMenu != null) {
            appsModule.setViewpointSelectionMenu(this.queryViewpointSelectionMenu === 'true');
        }

        if (this.queryChoiceSelectionMenu != null) {
            appsModule.setChoiceSelectionMenu(this.queryChoiceSelectionMenu === 'true');
        }

        if (this.queryFactorSelectionMenu != null) {
            appsModule.setFactorSelectionMenu(this.queryFactorSelectionMenu === 'true');
        }

        if (this.queryMbDraggable != null) {
            workspaceOptionsModule.setMbDraggable(this.queryMbDraggable === 'true');
        }

        if (this.queryStandardize != null) {
            workspaceOptionsModule.changeStandardizeDenominator(this.queryStandardize === 'true');
        }

        if ( this.queryDenomScoring != null) {
            workspaceOptionsModule.changeDenominatorScoring(this.queryDenomScoring === 'true')
        }

        if ( this.queryShowFactorData != null) {
            workspaceOptionsModule.changeShowFactorData(this.queryShowFactorData === 'true')
        }
    
        this.initialLoad = false;
    }

    @Watch('sliderLeft')
    sliderLeftChange(left: number) {
        if (left > -25) {
            left = -25;
        }
        this.sliderPageWidth[1] = -1 * left;
        this.sliderRight = -1 * left;
    }

    @Watch('sliderRight')
    sliderRightChange(right: number) {
        if (right < 25) {
            right = 25;
        }
        this.sliderPageWidth[0] = -1 * right;
        this.sliderLeft = -1 * right;
        this.$cookies.set('vp-form-width', this.sliderRight);
    }

    // @Watch('navDrawer')
    // navDrawerChange(newVal: boolean) {
    //     if (!newVal) {
    //         this.$emit('nav-drawer-changed', false);
    //     }
    // }

    // @Watch('navDrawerProp')
    // navDrawerPropChange(newVal: boolean) {
    //     this.navDrawer = newVal;
    //     this.openLeft = newVal;
    // }

    @Watch('$route', { immediate: true, deep: true })
    onRouteChange() {
        this.generateUrl();
    }

    private generateUrl() {
        let urlPath = this.$router.currentRoute.path;
        // kat(may5) - share dialog
        let currentUrl: any = {
            path: urlPath,
            params: ''
        };
        let params: any = {
            viewpointIds: viewpointsModule.selectedViewpointIds,
            decisionId: decisionsModule.selectedDecisionId,
            choiceId: choicesModule.selectedChoiceId,
            activeViewpointId: viewpointsModule.activeViewpointId,
            showNonContributing: workspaceOptionsModule.contributingFactorVisibility,
            // visibleChoices: Object.keys(workspaceOptionsModule.choiceVisibility).filter((k: string) => workspaceOptionsModule.choiceVisibility[k]),
            choiceListIds: workspaceOptionsModule.activeChoiceLists,
            factorListIds: workspaceOptionsModule.activeFactorLists,
            activeFactorId: workspaceOptionsModule.selectedPathItemId,
            viewpointListIds: workspaceOptionsModule.activeViewpointLists,
            showDesc: workspaceOptionsModule.descriptionVisibility.toString(),
            showBars: workspaceOptionsModule.scoreBarVisibility.toString(),
            showIconScoring: workspaceOptionsModule.showIconScoring,
            skipGroups: workspaceOptionsModule.skipGroups,
            showNonListFactors: workspaceOptionsModule.showNonListFactors,
            viewpointSort: workspaceOptionsModule.viewpointSort,
            choiceSort: workspaceOptionsModule.choiceSort,
            openLeft: workspaceOptionsModule.openLeft.toString(),
            openRight: workspaceOptionsModule.openRight.toString(),
            choiceColumnWidth: workspaceOptionsModule.choiceColumnWidth,
            viewpointColumnWidth: workspaceOptionsModule.viewpointColumnWidth,
            choiceNumOfCols: workspaceOptionsModule.numOfCols,
            trimTopGroups: workspaceOptionsModule.trimTopGroups,
            showScores: workspaceOptionsModule.scoresVisibility.toString(),
            showKeys: workspaceOptionsModule.keysVisibility.toString(),
            showComments: workspaceOptionsModule.commentsVisibility.toString(),
            choiceFirstCol: workspaceOptionsModule.choiceFirstCol,
            showCustomRange: workspaceOptionsModule.customRangeActive.toString(),
            viewpointFirstCol: workspaceOptionsModule.viewpointFirstCol,
            rankChoiceCol: workspaceOptionsModule.rankChoiceCol,
            pinnedRight: workspaceOptionsModule.pinnedRight.toString(),
            pinnedLeft: workspaceOptionsModule.pinnedLeft.toString(),
            commentVertical: workspaceOptionsModule.commentVertical.toString(),
            allowGenerateViewpoints: workspaceOptionsModule.allowGenerateViewpoints.toString(),
            selectionMenu: appsModule.selectionMenu.toString(),
            mbDraggable: workspaceOptionsModule.mbDraggable.toString(),
            denomScoring: workspaceOptionsModule.denominatorScoring.toString(),
            standardize: workspaceOptionsModule.standardizeDenominator.toString(),
            showFactorData: workspaceOptionsModule.showFactorData.toString(),
        };
        let path = '';
        if (Object.values(params).filter((f) => f).length > 0) {
            path = path + '?';
            for (let p in params) {
                if (params[p] && params[p] != null) {
                    if (Array.isArray(params[p]) && params[p].length > 0) {
                        path =
                            path +
                            (params[p] as any[])
                                .map((v) => p + '=' + v)
                                .join('&') +
                            '&';
                    } else if (!Array.isArray(params[p])) {
                        path = path + p + '=' + params[p] + '&';
                    }
                }
            }
            path = path.substring(0, path.length - 1);
        }
        // kat(may04)
        currentUrl.params = path;
        path = urlPath + path;
        workspaceOptionsModule.setCurrentUrl(currentUrl);
        //@ts-ignore
        history.pushState({}, null, path);
        this.fullPath = path;
        
        this.$emit('new-path', path);
        return path;
    }

    private recenterSlider(value: any[]) {
        if (value[0] > -25) {
            value[0] = -25;
            this.sliderPageWidth[0] = -25;
        }
        this.sliderLeft = value[0];
        if (value[1] < 25) {
            value[1] = 25;
            this.sliderPageWidth[1] = 25;
        }
        this.sliderRight = value[1];
    }

    private async createViewpoint(viewpoint: any) {
        this.emitProcessingMessage();
        this.createViewpointDialog = false;
        try {
            if (!this.selectedDecision) return;
            await decisionsModule.createDecisionViewpoint({
                decisionId: this.selectedDecision.decisionId,
                name: viewpoint.name,
                description: viewpoint.description,
            });
            this.emitSuccessMessage();
        } catch (err) {
            this.emitFailedMessage(err);
        }
    }

    private async createDecision(decisionInput: any) {
        this.createDecisionDialog = false;
        this.emitProcessingMessage();
        let newDecision = await decisionsModule.createDecision({
            name: decisionInput.name,
            description: decisionInput.description,
            choiceLabel: decisionInput.choiceLabel,
            viewpointLabel: decisionInput.viewpointLabel,
            factorLabel: decisionInput.factorLabel,
            pluralChoiceLabel: decisionInput.pluralChoiceLabel,
            pluralViewpointLabel: decisionInput.pluralViewpointLabel,
            pluralFactorLabel: decisionInput.pluralFactorLabel,
            scoringSuffix: decisionInput.scoringSuffix,
            scoringRangeMax: decisionInput.scoringRangeMax,
            commentAdminTags: decisionInput.commentAdminTags,
            commentUserTags: decisionInput.commentUserTags,
            tagsDecision: decisionInput.tagsDecision,
            tagsDataScience: decisionInput.tagsDataScience,
            tagsMarketplace: decisionInput.tagsMarketplace,
            templateApprovedKeys: decisionInput.templateApprovedKeys,
            stripeProductCode: decisionInput.stripeProductCode,
            templateIcon: decisionInput.templateIcon,
            templateLogo: decisionInput.templateLogo,
            templateImageCard: decisionInput.templateImageCard,
            templateImagePage: decisionInput.templateImagePage,
            templateDescriptionCard: decisionInput.templateDescriptionCard,
            templateDescriptionPage: decisionInput.templateDescriptionPage,
            templateTagline: decisionInput.templateTagline,
            decisionTemplateId: decisionInput.decisionTemplateId,
            templateApproved: decisionInput.templateApproved,
            templateEnabled: decisionInput.templateEnabled,
            templatePriceSingle: decisionInput.templatePriceSingle,
            templatePriceMonthly: decisionInput.templatePriceMonthly
        });
        await decisionsModule.selectDecision(newDecision.decisionId);
        this.emitSuccessMessage();
    }

    private async editDecision(payload: Decision) {
        this.editDecisionDialog = false;
        NotificationEventBus.emitProcessingMessage();
        try {
            // console.log(payload);
            await decisionsModule.updateDecision(payload);
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    private async publishDecision(payload: Decision) {
        this.editDecisionDialog = false;
        NotificationEventBus.emitProcessingMessage();
        let copy = _.cloneDeep(payload)
        try {
            if(payload.templatePriceMonthly) {
                let newProduct = await billingsDao.createProduct(payload.name, payload.templatePriceMonthly, payload.decisionId)
                if(newProduct.id) {
                    payload.stripeProductCode = newProduct.id
                }
            }
            await decisionsModule.updateDecision(payload);
            let cloneDecision = _.cloneDeep(payload)
            cloneDecision.decisionId = 'PUBLIC'
            let res = await appsModule.createTemplate({decisionId: copy.decisionId, payload: cloneDecision})
            await appsModule.addUserToApp({id: res.id, userId: usersModule.currentUserProfile.userId })
            const appRes = appsModule.apps;

            for ( let appItem of appRes ){
                // add new app to the market place
                console.log(`add app ${appItem.name}`)
                let appRes = await appsModule.createAppTemplate({decisionIdRef:copy.decisionId,app: appItem});
                console.log(appRes);
                await appsModule.addUserToAppWithApp({app: appRes, userId: usersModule.currentUserProfile.userId});
            }
            await appsModule.fetchMarketplaceItems();
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    private async syncDecision(payload: Decision) {
        this.editDecisionDialog = false;
        NotificationEventBus.emitProcessingMessage();
        // update Decision template
        let copy = _.cloneDeep(payload)

        try {
            // update decision
            let oldDecisionPrice = _.clone(decisionsModule.decisions[payload.decisionId].templatePriceMonthly)
            if(payload.templatePriceMonthly) {
                let newProduct = await billingsDao.createProduct(payload.name, copy.templatePriceMonthly, copy.decisionId)
                if(newProduct.object === 'price') {
                    payload.stripeProductCode = newProduct.id
                }
            }
            
            await decisionsModule.updateDecision(payload);
            // update decisionTemplate
            // delete apps template
            let cloneDecision = _.cloneDeep(payload) as any
            cloneDecision.decisionId = 'PUBLIC'
            let app = appsModule.decisionTemplatesDict[copy.decisionId]
            if(app.userIds)
                cloneDecision.userIds = app.userIds
            cloneDecision.decisionIdRef = copy.decisionId
            cloneDecision.type = 'TEMPLATE'
            cloneDecision.id = app.id
            await appsModule.updateTemplate({decisionId: 'PUBLIC', appId: app.id, app: cloneDecision});

            // update and add apps template
            // appRes, apps for the current decision
            const appRes = appsModule.apps;
            // marketplace app
            let marketplaceAppsDict = appsModule.appTemplatesDict;
            // marketplaceAppsByDecision - get all market places apps with current decision id
            let marketplaceAppsByDecision = appsModule.appTemplates.filter(x=> x.decisionIdRef === copy.decisionId && x.type === 'APP') as any[];
            for ( let appItem of appRes ){
                // check if the current app is in the market place
                if(marketplaceAppsDict[appItem.id]){
                    // update app in the market place
                    console.log(`update app ${appItem.name}`)
                    await appsModule.updateAppTemplate({appTemplate: marketplaceAppsDict[appItem.id], app:appItem})
                } else {
                    // add new app to the market place
                    console.log(`add app ${appItem.name}`)
                    let appRes = await appsModule.createAppTemplate({decisionIdRef:copy.decisionId,app: appItem})
                    await appsModule.addUserToAppWithApp({app: appRes, userId: usersModule.currentUserProfile.userId});
                }
            }
            // remove apptemplate if deleted in the decision
            for ( let appTemplate of marketplaceAppsByDecision ){
                if(appRes.findIndex(x=> x.id === appTemplate.appIdRef) === -1){
                    console.log(`delete app ${appTemplate.name}`)

                    await appsModule.deleteApps({decisionId: 'PUBLIC',appId: appTemplate.id})
                }
            }
            await appsModule.fetchMarketplaceItems();
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    private async removeDecision(payload: Decision) {
        this.editDecisionDialog = false;
        let copy = _.cloneDeep(payload)
        NotificationEventBus.emitProcessingMessage();
        try {
            let cloneDecision = _.cloneDeep(payload) as any
            cloneDecision.decisionId = 'PUBLIC'
            let appId = appsModule.decisionTemplatesDict[copy.decisionId].id
            // console.log(`delete app template ${appsModule.decisionTemplatesDict[copy.decisionId].name}`)
            // console.log(copy.decisionId);
            let apps = appsModule.appTemplates.filter(x => x.decisionIdRef === copy.decisionId);
            // console.log(apps);
            await VIEWPOINT_API.deleteApp('PUBLIC', appId);
            if(apps.length > 0 ){
                for (let app of apps){
                    // console.log(`delete app template ${app.name}`)
                    await VIEWPOINT_API.deleteApp('PUBLIC', app.id);
                }
            }
            await appsModule.fetchMarketplaceItems();
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    private emitProcessingMessage() {
        this.processing = true;
        NotificationEventBus.emitProcessingMessage();
    }

    private emitSuccessMessage() {
        this.processing = false;
        NotificationEventBus.emitSuccessMessage();
    }

    private emitFailedMessage(error: any) {
        this.processing = false;
        NotificationEventBus.emitFailedMessage(error);
    }

    private updateScoringKeyDefinition(scoringKeys: any[]) {
        let scoringKeyDefinition: ScoringKeyDefinition | null;
        if (scoringKeys == null || scoringKeys.length === 0) {
            scoringKeyDefinition = null;
        } else {
            scoringKeyDefinition = {
                scoringKeys: scoringKeys,
                notApplicableEnabled: false,
            };
        }

        NotificationEventBus.emitProcessingMessage();
        scoringKeysModule
            .updateDecisionScoringKeyDefinition(scoringKeyDefinition)
            .then(() => {})
            .catch((error: any) => {
                NotificationEventBus.emitFailedMessage({
                    message: error.message,
                });
            });
    }

    // if appModule has an selected app's url, return the url
    // if not, return the original app's url
    private getAppPath(){
        // console.log('getPath');
        // console.log(this.$cookies.get('currentAppUrl'));
        let re = new RegExp('^[\/]{1}([aApP]{3}[\/]{1}){1}');
        if(appsModule.currentAppUrl !== "" && re.test(appsModule.currentAppUrl)){
            return appsModule.currentAppUrl;
        }else{
            return '/app' + this.fullPath;
        }
    }

    
    private async calculateNow() {
        if(this.activeViewpointId){
            await scoringModule.recalculateAllChoiceScores(this.activeViewpointId);
        }
        if(this.selectedViewpointIds && this.selectedViewpointIds.length > 0){
            this.selectedViewpointIds.forEach(async (x) => {
                await scoringModule.recalculateAllChoiceScores(x);
            })
        }
        
    }
    private openRightToggler(){
        this.openRight = !this.openRight
        if(!this.openRight){
            this.pinnedRight = false;
        }
    }
}
